import styled from 'styled-components/macro'

import { Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { Icon } from 'core/ui/components/icon/Icon'

import { type EquipmentType } from '../../core/domain/EquipmentType'
import { type EquipmentSize } from '../domain/EquipmentSize'
import { type Mode } from '../domain/Mode'
import { isDrayageMode } from '../domain/RequestForProposal'
import { getEquipmentTypeAndSizeLabel } from '../presenters/equipmentSizePresenter'
import { getEquipmentType } from '../presenters/equipmentTypePresenter'

export type RfpEquipmentProps = {
  equipmentType: EquipmentType
  equipmentSize: EquipmentSize
  rfpMode: Mode
}

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  gap: ${getToken('space-xs')};
`

export function RfpEquipment(props: RfpEquipmentProps) {
  const equipmentType = getEquipmentType(props.equipmentType)
  const showSize = isDrayageMode(props.rfpMode)
  const label = getEquipmentTypeAndSizeLabel(props.equipmentType, props.equipmentSize, showSize)

  if (equipmentType) {
    return (
      <Wrapper>
        <Icon name={equipmentType.icon} size="18px" />
        <Text>{label}</Text>
      </Wrapper>
    )
  }

  return <Text>{label}</Text>
}
